import { render, staticRenderFns } from "./RichButton.vue?vue&type=template&id=2560664e"
import script from "./RichButton.vue?vue&type=script&lang=js"
export * from "./RichButton.vue?vue&type=script&lang=js"
import style0 from "./RichButton.vue?vue&type=style&index=0&id=2560664e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports